import { UserListItem } from '../../types'

const users: UserListItem[] = [
	{
		id: 1,
		email: 'callum@mondago.com',
		name: 'Callum Douglas',
		group: 'uk',
		disabled: false,
		api_enabled: true,
		roles: [
			{
				id: 1,
				name: 'Mondago Administrator'
			}
		],
		organizations: []
	},
	{
		id: 6,
		email: 'useroned@mondago.com',
		name: 'User One',
		group: 'us',
		disabled: true,
		api_enabled: true,
		roles: [
			{
				id: 1,
				name: 'Service Provider Administrator'
			}
		],
		organizations: [{
			id: 1,
			name: 'Hooli'
		}]
	}
]

export default users
